import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 112	悬浮组件开关
 */

export default class EventFloatControl extends EventBase {
  /**
   * 悬浮组件开关构造函数
   */
  constructor() {
    super()
    //this.Parameter = [ "0", "" ];
    this.Parameter = ['0', '', ''] //参数1：开关状态(0:关 1:开)；参数2：显示信息；参数3：选择组件ID（小于0表示全部）
  }
  /**
   * 事件ID
   */
  Code = EventID.FloatControl
  // #region 类的绑定数据相关参数都在这
  /**
   * 开关状态(0:关 1:开)
   */
  get IsOpen() {
    return parseInt(this.Parameter?.[0] ?? '') == 1 ? true : false
  }
  set IsOpen(value) {
    this.Parameter![0] = value ? '1' : '0'
  }

  /**
   * 选择组件ID（小于0表示全部）
   */
  get SelectID() {
    if (this.Parameter?.[2]) {
      return parseInt(this.Parameter?.[2] ?? '')
    }
    return -1
  }

  set SelectID(value) {
    this.Parameter![2] = value.toString()
  }

  /**
   * 显示信息
   */
  get Description() {
    return this.Parameter?.[1] || ''
  }
  set Description(value) {
    this.Parameter![1] = value.toString()
  }

  //   // #endregion
  /**
   * 获取显示信息
   */
  /// <returns></returns>
}
